<style scoped>

.about-text {
    font-size: 16px;
    color: #212322;
    text-align: justify;
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 20px;
    padding-right: 280px;
}

.larger_text {
    font-size: 20px;
    color: #696969;
  
}

.larger_text_2 {
      font-size: 20px;

}

h3 {
    font-family: "Open Sans", sans-serif;
    font-size: 30px;
    font-weight: bold;
}

p {
    font-family: "Inconsolata", monospace;
}



a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: #696969;
}
.cv_sub {
  font-size: 24px;

}

@media (max-width: 575px) {
  p {
    text-align: left;
    line-height: 1.6;
    
  }

  .about-text {
    padding-right: 10px;
  }

  br {
   display: block;
   margin: 10px 0;
}

.larger_text {
    font-size: 20px;
    font-weight: bold;
    color: #696969;
  
}

pre {
  display: none;
}
}
</style>

<template>

<div>
    <MenuBar/>
    <b-row class="about-text">
        <b-col md="10">
          <div class='larger_text_2'>
          <p>Alice Strete (1991, RO/NL) is a cultural worker/artist/cook/researcher based in Rotterdam. <br>Member of <a href="http://varia.zone/">Varia</a> and co-founding member of <a href="https://biobulkbende.org/">Biobulkbende</a> food co-operative.</p>

          <p>strt [@] riseup [dot] net or <a href="https://www.instagram.com/alicestrt/" target="_blank">Instagram</a> or <a href="https://post.lurk.org/@alcstrt" target="_blank">Mastodon</a>. 
          </p>
          </div>


<pre>


.  |   o * * ' . .        . '  * '     +  .-.  .     .:'  .  . '  * '  * * .  . .  '  . 
  -+-              +~~ '             /   ( (     _.::'      o           ' *    *     +    '
_| |  ' ':.      '       o .   / *  /     `-'  | _.'    + '   o .   / *  . '  + + '
 |        '::._      .        /    *   +      -o-                  /    * +     *     +   
    ' o     '._)  '     o  ' *   o       .  o  |  '  . o ' + .  ' *   o  . . o . + 


</pre>

<p class="cv_sub">Art and Research </p>
  
  <p>
  <span class="larger_text">2026, <a href="https://varia.zone/en/2026/how_to_unionise/">How to Organise, and Unionise?!</a></span>, research and reading group with a. pickles, NL <br> 
  <span class="larger_text">2026, <a href="https://afnr.nl/">AFNR</a></span>, research on alternative food networks and radio show with B. Earl and D. Garcia-Caro, NL <br>
  <span class="larger_text">2025, <a href="https://varia.zone/en/rural-technology-rachelle-eerhart.html">Rural tech</a></span>, radio show with B. Earl and D. Garcia-Caro, Varia, NL <br>
  <span class="larger_text">2025, <a href="https://www.garagerotterdam.nl/activiteiten/disaster-cooking/">Meals for Inner Peace Research Center</a></span>, research and thematic dinner, Garage, NL<br>
  <span class="larger_text">2025, <a href="https://varia.zone/en/2025/money-talks/">Money Talks</a></span>, research and event with a. pickles, Varia, NL<br>
  <span class="larger_text">2025-2026 <a href="https://varia.zone/en/self-medicated-practices-diy.html">Self-Medicated Practices</a></span>, workshop series with Y. Buzova, Varia, NL <br>
  <span class="larger_text">2024, <a href="https://varia.zone/en/whine-dine-decline.html">Whine, Dine and Decline</a></span>, thematic dinner with Y. Buzova, Varia, NL <br>
  <span class="larger_text">2024, <a href="https://varia.zone/en/common-dirt.html">Common Dirt (Spring Edition)</a></span> guided tour with Y. Buzova and N. Hilkmann, Varia, NL <br>
  <span class="larger_text">2023, <a href="https://varia.zone/en/doing-the-dishes-and-then-revolution.html">Doing the Dishes and then Revolution</a></span>, collective session, Varia, NL <br>
  <span class="larger_text">2023, <a href="https://varia.zone/en/sometimes-not-available-transfeminist-digital-care-network.html">Sometimes Not Available</a></span> collective sessions with C. Cochior, Varia, NL <br>
  <span class="larger_text">2023, <a href="https://varia.zone/en/varia-afhaal-chip-shortage.html">Varia Afhaal</a></span>, collective sessions with Y. Buzova and S. Browne, Varia NL <br>
  <!-- <span class="larger_text">2023, <a href="https://www.eventbrite.nl/e/situated-kitchen-ultratranslation-marathon-tickets-602491948637">Situated Kitchen Ultratranslation Marathon</a></span>, work session part of the Ultradependent Public School, BAK, NL <br> -->
  <span class="larger_text">2023, <a href="https://www.bakonline.org/program-item/sancochotopia-a-winter-ultrahospitality-mini-garage-school/">Sancochotopia</a></span>, work session part of the Ultradependent Public School, BAK, NL <br>
  <span class="larger_text">2023, <a href="https://www.domainepublic.net/Now-think-of-a-question-that-is-at-stake-for-you.html">Now Think of a Question that Is at Stake for You</a></span>, installation and workshop with C. Cochior, Constant, BE <br>
  <span class="larger_text">2022, <a href="https://vvvvvvaria.org/archive/2022-07-documenta15-harvesters/">Varia harvest of lumbung.space</a></span>, publishing experiment, documenta15, DE <br>
  <span class="larger_text">2021-2022, <a href="https://varia.zone/en/atnofs-varia.html">A Traversal Network of Feminist Servers</a></span>, event series, NL RO AT GR BE <br>
  <span class="larger_text">2021, <a href="https://ontheradio.recipes/">Recipes on the Radio</a></span>, radio show with Y. Buzova on WORM Radio, NL<br>
  <span class="larger_text">2021, <a href="http://relearn.be/2021/">Relearn</a></span>, co-organiser with S.Pinol and L. Murphy, collective learning experiment and summer school, NL<br>
  <span class="larger_text">2020-present, <a href="https://fizz.varia.zone/">Fizz Club</a></span>, a fermentation gathering  with S. Pinol and L. Murphy at Varia, NL <br>
  <span class="larger_text">2020, <a href="https://a-nourishing-network.radical-openness.org/">A Nourishing Network</a></span>, publishing project, with M. Berends and servus, AT<br> 
  <span class="larger_text">2020, <a href="https://feministsearchtools.nl/">Feminist Search Tools</a></span>, design and development with A. Diakrousi, NL <br>

<!-- 2019, <a href="https://www.gaite-lyrique.net/evenement/grrrls-tech-zine-fair">Grrrls Tech Zine Fair</a>, Gaîté Lyrique,
Participated with over/under, Techno/Cyber/Xeno-Feminism, Paris, FR<br> -->
<span class="larger_text">2018, <a href="https://sign2.nl/events/timeline-intervention-happiness-project-alice-strete-angeliki-diakrousi/">The Happiness Project</a></span>, public intervention with A. Diakrousi, Timeline Gallery, NL<br>
  </p>

<p class="cv_sub">Lectures & talks & workshops</p>
  <p>
<span class="larger_text">2026, <a href="https://hackersanddesigners.nl/get-paid.html">Melon 3 launch</a></span>, talk and cooking session, Books are Bridges Art Book Fair, Printroom, Rotterdam, NL<br>
<span class="larger_text">2026, <a href="https://hackersanddesigners.nl/get-paid.html">Get Paid</a></span>, talk, Hackers and Designers Summer Camp, Amsterdam, NL<br>
<span class="larger_text">2025, <a href="https://institutfrancais.sk/fr/podujatie/medzinarodna-konferencia-after-industry/">Self-Governance in Server-Practices</a></span>, talk and panel discussion with a. pickles, After Industry International Conference, SK <br>
<span class="larger_text">2024, <a href="https://www.mfru.org/projects/discount-cui-zine-social-nourishment-court">Discount Cui-zine</a></span>, workshop, MFRU30, SI <br>
<span class="larger_text">2023, 2024 <a href="https://www.hslu.ch/de-ch/design-kunst/studium/interdisziplinaere-module/colabor/modulangebot-2023/co-120/">Situated Infrastructures</a></span>, guest talk and workshop with A. Gryllaki at HSLU, CH <br>
<span class="larger_text">2023, <a href="https://www.dcci.ie/events/artist-led-server-networks/">Artist-Led Server Networks</a></span>, workshop with L. Murphy and S. Browne, Irish Design Week, IE <br>
<span class="larger_text">2023, <a href="https://sfpc.study/sessions/spring-23/solidarity-infra">Solidarity Infrastructures</a></span>, guest talk with C. Cochior and D. Tirthdas van der Kleij, SFPC, USA <br>
<span class="larger_text">2022, <a href="https://art-meets.radical-openness.org/program/amro-times/">AMRO Times</a></span>, work session with M. Berends at AMRO 2022, AT <br>
<span class="larger_text">2022, <a href="https://art-meets.radical-openness.org/program/hosting-with-the-others/">Hosting with the Others</a></span>, panel discussion, AMRO, AT <br>
<span class="larger_text">2021, <a href="https://2021.designweek.melbourne/events/ideas-for-humanity-a-cookbook-for-planetary-health/">A short lecture on cookbooks and other problems</a></span>, guest talk, UAL, UK <br>
<span class="larger_text">2021, <a href="https://hackersanddesigners.nl/s/Summer_Academy_2021/p/Reading_food_with_Relearn_and_Varia">Reading Food</a></span>, workshop with S. Pinol, Hackers&Designers Summer Academy 2021, NL<br>
<span class="larger_text">2021, <a href="https://libregraphicsmeeting.org/2021/en/presentation15.html">A Nourishing Network</a></span>, lecture with M. Berends, Libre Graphics Meeting, FR <br>
<span class="larger_text">2020, <a href="https://beyond-social.org/wiki/index.php/Vulnerable_Publishing_Workshop">Vulnerable Publishing</a></span>, workshop series with A. Diakrousi, WDKA, NL <br>
<span class="larger_text">2020, <a href="https://hackersanddesigners.nl/s/Events/p/Workshop%3A_Repository_of_Feminist_Search_Strategies">Repository of Feminist Search Strategies</a></span>, Workshop with Hackers&Designers, NL<br>
<span class="larger_text">2018, <a href="https://gitlab.constantvzw.org/zine-machines">Zine Machines Workshop</a></span>, SIGN, Spread Zinefest, NL<br>
  </p>

<p class="cv_sub"> Exhibitions </p>
  <p>
<span class="larger_text">2025, <a href="https://screensaver.gallery/chaline-bang-ren-loren-britton-alice-strete-col-cristina-cochior-hands-that-hold-the-networks">rosa_diagram</a></span>, Hands that Hold the Networks collective exhibition, Screensaver Gallery, online <br>
<span class="larger_text">2024-2025, <a href="https://roodkapje.org/anarchief/">Twice Removed</a></span>, installation, part of Anarchive group exhibition, Roodkapje, NL <br>
<span class="larger_text">2022, <a href="https://qujochoe.org/el-queso/">1/cm2</a></span>, short film, El Queso group exhibition by qujOchÖ, AT <br>
<span class="larger_text">2020, <a href="https://esc.mur.at/en/projekt/cyborg-subjects">Cyborg Subjects</a></span>, group exhibition, esc kunst medien labor, AT<br>
<span class="larger_text">2019, <a href="https://project.xpub.nl/is-it-time-to-eat-or-is-there-no-more-time-to-eat/">Is it time to eat, or is there no more time to eat?</a></span>, Upsetting Settings Graduation Show, Piet Zwart Institute, NL<br>
<span class="larger_text">2018, <a href="https://issue.xpub.nl/06/">XPPL</a></span>, Interfacing the Law Group Show, Piet Zwart Institute, NL<br>
<span class="larger_text">2018, <a href="https://issue.xpub.nl/05/">OuNuPo</a></span>, Group show, Piet Zwart Institute, NL<br>
<span class="larger_text">2018, <a href="https://www.tentrotterdam.nl/event/the-temporary-autonomous-bureau-anomalous-institutions/">Temporary Autonomous Bureau</a></span>, TENT Gallery, Rotterdam Cultural Histories, Group exhibition, NL
  </p>

<p class="cv_sub">Publications and writing</p>
  <p>
<span class="larger_text">2026, <a href="https://limestonebooks.org/products/melon-3-meals-for-the-final-72-hours-living-and-eating-through-ongoing-collapse">Melon 3</a></span>, author and co-editor, Limestone Books, Maastricht, NL <br>  
<span class="larger_text">2026, <a href="https://varia.zone/en/2026/sometimes9/">Sometimes 9</a></span>, author and editor, Varia, NL <br>
<span class="larger_text">2025-2026 <a href="https://varia.zone/en/2026/self-medicated-publication/">Self-Medicated Practices</a></span>, editor and author, NL <br>
<span class="larger_text">2024, Self-Organised Spreads</span>, editor and author, NL <br>
<span class="larger_text">2024, <a href="https://another.varia.zone/">Stock Making Sense</a></span>, essay, co-writer, NL <br>
<span class="larger_text">2023, <a href="https://varia.zone/en/atnofs-publication.html">ATNOFS publication</a></span>, editor and author, NL <br>
<span class="larger_text">2022, <a href="https://hackersanddesigners.nl/p/First,_Then..._Repeat._Workshop_Scripts_in_Practice">First, Then… Repeat. Workshop Scripts in Practice</a></span>, ed. Anja Groten, contributor, NL <br>
<span class="larger_text">2022, <a href="https://art-meets.radical-openness.org/program/amro-times/">AMRO Times</a></span>, editor and designer, AT <br>
<span class="larger_text">2020-2021, <a href="https://magiun.alicestrete.me">Magiun Magazine</a></span>, editor, author, producer, NL <br>
<span class="larger_text">2020, <a href="https://wellsofknowledge.wdka.nl/">Wells of Knowledge</a></span>, hybrid publication project, WDKA, with A. Diakrousi, NL<br>
<span class="larger_text">2020, <a href="https://code-art.xyz/pdfs/issue0.pdf">Code::Art Journal</a></span>, contributor, UK<br>
<span class="larger_text">2019, <a href="https://portfolio.alicestrete.me/catalogue">Upsetting Settings Catalogue</a></span>, editor, author and producer, NL <br>
<span class="larger_text">2019, <a href="https://portfolio.alicestrete.me/upsetting">Upsetting Settings, Collected Works</a></span>, editor, author and producer, NL<br>
<span class="larger_text">2019, <a href="https://portfolio.alicestrete.me/overunder">Over/Under zine</a></span>, author and designer, Rotterdam, NL<br>
<span class="larger_text">2018, <a href="https://portfolio.alicestrete.me/xeno">Techno/Cyber/Xeno-Feminism Reader</a></span>, author and designer, Rotterdam, NL<br>
<span class="larger_text">2017, <a href="https://issue.xpub.nl/04/">A Bed, a Chair and a Table</a></span>, author and editor, Rotterdam, NL
  </p>

<p class="cv_sub">Work</p>
  <p>
<span class="larger_text">2024-2025, Villa Augustus</span>, cook <br>  
<span class="larger_text">2024, Piet Zwart Institute</span>, Guest tutor in Experimental Publishing for <a href="https://issue.xpub.nl/23/">Special Issue 23</a><br>  
<span class="larger_text">2021-2023, Willem de Kooning Academy</span>, Tutor in Autonomous Practices minor, Hacking and Digital Craft<br>
<span class="larger_text">2019-2021, Willem de Kooning Academy</span>, Researcher
Developer of publishing platform <a href="https://beyond-social.org/wiki/index.php/Main_Page">Beyond Social</a> within the
Social Practices minor, workshop facilitator, substitute tutor <br>
<!-- <span class="larger_text">2016-2021,
Fairplanet.org</span>, Social Media Manager for a non-profit independent
solution journalism platform focused on human rights and the environment. -->
</p>
<p class="cv_sub">Education</p>
<p>
<span class="larger_text">2017-2019, Piet Zwart Institute</span>, Willem de Kooning Academy, Master of Arts in Fine Art and Design: Experimental Publishing, NL <br>
<span class="larger_text">2013-2014, Dublin City University</span>, Erasmus Semester, Communication Studies, IE <br>
<span class="larger_text">2011-2014, Babes-Bolyai University</span>, Bachelor, Faculty of Political, Administrative and Communication Studies, RO</p>

<p class="cv_sub">Awards/Grants</p>
<p>
  <span class="larger_text">2025, Partial Scholarship</span>, MAD Academy, DK <br>
  <span class="larger_text">2024, Tool Sheds Fellowship</span>, Het Nieuwe Instituut <br>
  <span class="larger_text">2021-2026, 1 and 2-year Activities Programme as Varia</span>, Stimuleringsfonds <br>
  <span class="larger_text">2021, Culture of Solidarity Fund</span>, European Cultural Foundation <br>
  <span class="larger_text">2021, Makersloket Grant</span>, Stichting Droom en Daad <br>
  <span class="larger_text">2018, Grada van Beek-Donner Scholarship</span>, Van Beek-Donner Stichting</p>

        </b-col>
    </b-row>
<b-row class="about-text">
  <pre>


.  |   o * * ' . .        . '  * '     +  .-.  .     .:'  .  . '  * '  * * .  . .  '  . 
  -+-              +~~ '             /   ( (     _.::'      o           ' *    *     +    '
_| |  ' ':.      '       o .   / *  /     `-'  | _.'    + '   o .   / *  . '  + + '
 |        '::._      .        /    *   +      -o-                  /    * +     *     +   
    ' o     '._)  '     o  ' *   o       .  o  |  '  . o ' + .  ' *   o  . . o . + 


</pre>
    <p>

    This website is built using BootstrapVue by Alice Strete.
</p>
</b-row>



</div>

</template>

<script>

import MenuBar from './MenuBar'
export default {
    name: 'AboutPage',
    components: {
        MenuBar
    }
}

</script>
